class MC_DiplomasChoice {
    constructor() {
     this.pickDiplom();
    }

    pickDiplom() {
     let diplomasContainer = document.querySelector('.templates-radio-list');
     if(!diplomasContainer) {
      return
     }
     let diplomasItem = diplomasContainer.querySelectorAll('.templates-radio-list LI INPUT');
     let formBlock = document.querySelector('.form-block');

     for (let i = 0; i < diplomasItem.length; i++) {
      diplomasItem[i].addEventListener('click', function() {
       let elementChoosen = diplomasItem[i].getAttribute('id');
       formBlock.querySelectorAll('.diploma-fields').forEach(element => {
        element.style.display = 'none';
       })
       formBlock.querySelector(`.${elementChoosen}`).style.display = 'block';
       formBlock.querySelectorAll(`.diploma-fields.${elementChoosen}`).forEach(element => {
        element.style.display = 'block';
       })
      })
     }
    }
   }
